'use client';

import { useClickOutside } from '@/hooks/useClickOutside';
import { cn } from '@/lib/utils';
import React, { ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export const Modal = ({
  className = '',
  open,
  onClose,
  children,
}: {
  className?: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  useClickOutside(contentRef, onClose);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    open &&
    createPortal(
      <dialog
        className={cn(
          'fixed left-0 top-0 z-40 flex h-screen w-screen items-center justify-center bg-[#00000080] p-600 backdrop-blur-[1.5px]',
        )}
      >
        <div
          className={cn(
            'shadow-xl max-h-full overflow-y-auto rounded-300 bg-white p-600',
            className,
          )}
          ref={contentRef}
        >
          {children}
        </div>
      </dialog>,
      document.body,
    )
  );
};
